function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.66666 4C1.56209 4 0.66666 3.10457 0.66666 2C0.66666 0.89543 1.56209 -7.76805e-07 2.66666 -7.28523e-07C3.77123 -6.80241e-07 4.66666 0.89543 4.66666 2C4.66666 3.10457 3.77123 4 2.66666 4Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99999 4C8.89542 4 7.99999 3.10457 7.99999 2C7.99999 0.89543 8.89542 -4.56255e-07 9.99999 -4.07973e-07C11.1046 -3.59691e-07 12 0.89543 12 2C12 3.10457 11.1046 4 9.99999 4Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3333 4C16.2288 4 15.3333 3.10457 15.3333 2C15.3333 0.89543 16.2288 -1.35705e-07 17.3333 -8.74228e-08C18.4379 -3.91405e-08 19.3333 0.895431 19.3333 2C19.3333 3.10457 18.4379 4 17.3333 4Z",
  fill: "white"
});

function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.9bf56e91.svg";
export { ForwardRef as ReactComponent };